import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { aboveBottomBar } from './mobileChrome';

export interface MobileToastProps {
  open: boolean;
  message: React.ReactNode;
  severity: 'success' | 'error' | 'info' | 'warning';
  onClose: () => void;
}

/** How long a success message stays, ms. Errors stay until closed. */
const SUCCESS_HIDE_MS = 6000;

/**
 * A short message for the phone layout ("Pour stopped."), bottom centre and
 * above the bottom bar and the iOS home bar. Success hides itself after
 * 6 s; anything else stays until the user closes it.
 */
export const MobileToast: React.FC<MobileToastProps> = ({ open, message, severity, onClose }) => (
  <Snackbar
    open={open}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    autoHideDuration={severity === 'success' ? SUCCESS_HIDE_MS : null}
    onClose={(_event, reason) => {
      // A tap elsewhere on the page must not dismiss an error unread.
      if (reason === 'clickaway') return;
      onClose();
    }}
    // Set per breakpoint: Snackbar's own bottom from sm up is a media rule,
    // which a plain value would not beat on tablets (600-899px).
    sx={{ bottom: { xs: aboveBottomBar(8), sm: aboveBottomBar(8) } }}
  >
    <Alert
      severity={severity}
      variant="filled"
      onClose={onClose}
      sx={{
        width: '100%',
        alignItems: 'center',
        // The close button at a 44px touch size (MUI's is a small one).
        '& .MuiAlert-action': { py: 0, alignItems: 'center' },
        '& .MuiAlert-action .MuiIconButton-root': { width: 44, height: 44 },
      }}
    >
      {message}
    </Alert>
  </Snackbar>
);

export default MobileToast;
